import type { PricingTableCurrency } from '@getaccept/editor-lib';

export const allCurrencies: PricingTableCurrency[] = [
  { label: 'EUR', currencyCode: 'EUR', locale: 'fr-DE', flag: '🇪🇺' },
  { label: 'Germany - EUR', currencyCode: 'EUR', locale: 'de-DE', flag: '🇩🇪' },
  { label: 'France - EUR', currencyCode: 'EUR', locale: 'fr-FR', flag: '🇫🇷' },
  { label: 'Italy - EUR', currencyCode: 'EUR', locale: 'it-IT', flag: '🇮🇹' },
  { label: 'Spain - EUR', currencyCode: 'EUR', locale: 'es-ES', flag: '🇪🇸' },
  { label: 'Netherlands - EUR', currencyCode: 'EUR', locale: 'nl-NL', flag: '🇳🇱' },
  { label: 'Belgium - EUR', currencyCode: 'EUR', locale: 'nl-BE', flag: '🇧🇪' },
  { label: 'Greece - EUR', currencyCode: 'EUR', locale: 'el-GR', flag: '🇬🇷' },
  { label: 'Portugal - EUR', currencyCode: 'EUR', locale: 'pt-PT', flag: '🇵🇹' },
  { label: 'Austria - EUR', currencyCode: 'EUR', locale: 'de-AT', flag: '🇦🇹' },
  { label: 'Finland - EUR', currencyCode: 'EUR', locale: 'fi-FI', flag: '🇫🇮' },
  { label: 'Slovakia - EUR', currencyCode: 'EUR', locale: 'sk-SK', flag: '🇸🇰' },
  { label: 'Ireland - EUR', currencyCode: 'EUR', locale: 'en-IE', flag: '🇮🇪' },
  { label: 'Lithuania - EUR', currencyCode: 'EUR', locale: 'lt-LT', flag: '🇱🇹' },
  { label: 'Slovenia - EUR', currencyCode: 'EUR', locale: 'sl-SI', flag: '🇸🇮' },
  { label: 'Latvia - EUR', currencyCode: 'EUR', locale: 'lv-LV', flag: '🇱🇻' },
  { label: 'Estonia - EUR', currencyCode: 'EUR', locale: 'et-EE', flag: '🇪🇪' },
  { label: 'Cyprus - EUR', currencyCode: 'EUR', locale: 'el-CY', flag: '🇨🇾' },
  { label: 'Luxembourg - EUR', currencyCode: 'EUR', locale: 'lb-LU', flag: '🇱🇺' },
  { label: 'Malta - EUR', currencyCode: 'EUR', locale: 'mt-MT', flag: '🇲🇹' },
  { label: 'United States - USD', currencyCode: 'USD', locale: 'en-US', flag: '🇺🇸' },
  { label: 'United kingdom - GBP', currencyCode: 'GBP', locale: 'en-GB', flag: '🇬🇧' },
  { label: 'Canada - CAD', currencyCode: 'CAD', locale: 'en-CA', flag: '🇨🇦' },
  { label: 'Hong kong - HKD', currencyCode: 'HKD', locale: 'en-HK', flag: '🇭🇰' },
  { label: 'Singapore - SGD', currencyCode: 'SGD', locale: 'en-SG', flag: '🇸🇬' },
  { label: 'Switzerland - CHF', currencyCode: 'CHF', locale: 'de-CH', flag: '🇨🇭' },
  { label: 'Japan - JPY', currencyCode: 'JPY', locale: 'ja-JP', flag: '🇯🇵' },
  { label: 'Sweden - SEK', currencyCode: 'SEK', locale: 'sv-SE', flag: '🇸🇪' },
  { label: 'Sweden - Öre', currencyCode: 'ORE', customName: 'SEK', locale: 'sv-SE', flag: '🇸🇪' },
  { label: 'Denmark - DKK', currencyCode: 'DKK', locale: 'da-DK', flag: '🇩🇰' },
  { label: 'Norway - NOK', currencyCode: 'NOK', locale: 'nn-NO', flag: '🇳🇴' },
  { label: 'Brazil - BRL', currencyCode: 'BRL', locale: 'pt-BR', flag: '🇧🇷' },
  { label: 'India - INR', currencyCode: 'INR', locale: 'hi-IN', flag: '🇮🇳' },
  { label: 'South Africa - ZAR', currencyCode: 'ZAR', locale: 'af-ZA', flag: '🇿🇦' },
  { label: 'Australia - AUD', currencyCode: 'AUD', locale: 'en-AU', flag: '🇦🇺' },
  { label: 'New Zealand - NZD', currencyCode: 'NZD', locale: 'en-NZ', flag: '🇳🇿' },
  { label: 'Thailand - THB', currencyCode: 'THB', locale: 'th-TH', flag: '🇹🇭' },
  { label: 'Poland - PLN', currencyCode: 'PLN', locale: 'pl-PL', flag: '🇵🇱' },
  { label: 'Lebanon - LBP', currencyCode: 'LBP', locale: 'en-LB', flag: '🇱🇧' },
  { label: 'Bahrain - BHD', currencyCode: 'BHD', locale: 'en-BH', flag: '🇧🇭' },
  { label: 'Jordan - JOD', currencyCode: 'JOD', locale: 'en-JO', flag: '🇯🇴' },
  { label: 'Saudi Arabia - SAR', currencyCode: 'SAR', locale: 'en-SA', flag: '🇸🇦' },
  { label: 'United Arab Emirates - AED', currencyCode: 'AED', locale: 'en-AE', flag: '🇦🇪' },
  { label: 'India - INR', currencyCode: 'INR', locale: 'en-IN', flag: '🇮🇳' },
  { label: 'Mexico - MXN', currencyCode: 'MXN', locale: 'es-MX', flag: '🇲🇽' },
  { label: 'Colombia - COP', currencyCode: 'COP', locale: 'es-CO', flag: '🇨🇴' },
  { label: 'Morocco - MAD', currencyCode: 'MAD', locale: 'en-MA', flag: '🇲🇦' },
  { label: 'Algeria - DZD', currencyCode: 'DZD', locale: 'en-DZ', flag: '🇩🇿' },
  { label: 'Tunisia - TND', currencyCode: 'TND', locale: 'en-TN', flag: '🇹🇳' },
];
